<template>
  <div class="table1">
    <table width="width" border="1">
      <tr class="backColorHui">
        <th>基金代码</th>
        <th class="Width2" style="text-align:left;">基金名称</th>
        <th>持债数量(张)</th>
        <th>数量变化(张)</th>
        <th>最新市值(万元)</th>
        <th>报告期市值(万元)</th>
        <th>占发行量比</th>
        <th>市值变化(万元)</th>
      </tr>
      <tr v-for="(item,index) in tableData" :key="'1' + index">
        <td style="text-align:center">{{item.data1}}</td>
        <td>{{item.data2}}</td>
        <td>{{item.data3}}</td>
        <td>{{item.data4}}</td>
        <td>{{item.data5}}</td>
        <td>{{item.data6}}</td>
        <td>{{item.data7}}</td>
        <td>{{item.data8}}</td>
      </tr>
      <tr>
        <td colspan='8' style="text-align:center">
          展开更多<img src="../../../../public/img/income_Info/xiala.png" alt="">
        </td>
      </tr>
      <tr>
        <td colspan='2'>共68个基金 合计</td>
        <td>897416</td>
        <td></td>
        <td>93014.38</td>
        <td>74172.00</td>
        <td>13.24%</td>
        <td></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data(){
    return{
      tableData:[
        {
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'新进'
        },{
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'101.40'
        },{
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'0.22'
        },{
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'新进'
        },{
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'新进'
        },{
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'新进'
        },{
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'新进'
        },{
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'新进'
        },{
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'新进'
        },{
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'新进'
        },{
          data1:'002351',
          data2:'易方达余香',
          data3:'104.64',
          data4:'新进',
          data5:'104.64',
          data6:'6.39%',
          data7:'3.69%',
          data8:'新进'
        },
      ]
    }
  }
};
</script>

<style scoped>
.table1 {
  margin-top: 24px;
  
}
table {
  border-collapse: collapse;
  border-color: #e9ebf3;
}
td {
  height: 16px;
  width: 104px;
  padding: 28px 18px;
  font-size: 16px;
  letter-spacing: 0px;
  color: #666666;
}
td img{
  width: 14px;
	height: 8px;
  margin-left: 6px;
  vertical-align: middle;
}
th{
  width: 130px;
	height: 16px;
  padding: 20px 5px;
  font-size: 16px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.Width2 {
  width: 469px;
}
@import url('../../../../public/css/public.css')
</style>